var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommentMention(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.96875C4.46875 0.96875 0.015625 5.42188 0.015625 10.9531C0.015625 16.4844 4.46875 20.9375 10 20.9375H15.0156V18.9688H10C5.64062 18.9688 1.98438 15.3125 1.98438 10.9531C1.98438 6.59375 5.64062 2.9375 10 2.9375C14.3594 2.9375 18.0156 6.59375 18.0156 10.9531V12.3594C18.0156 13.1562 17.3125 13.9531 16.5156 13.9531C15.7188 13.9531 15.0156 13.1562 15.0156 12.3594V10.9531C15.0156 8.1875 12.7656 5.9375 10 5.9375C7.23438 5.9375 4.98438 8.1875 4.98438 10.9531C4.98438 13.7188 7.23438 15.9688 10 15.9688C11.3594 15.9688 12.625 15.4062 13.5625 14.4688C14.1719 15.3594 15.2969 15.9688 16.5156 15.9688C18.4844 15.9688 19.9844 14.3281 19.9844 12.3594V10.9531C19.9844 5.42188 15.5312 0.96875 10 0.96875ZM10 13.9531C8.35938 13.9531 7 12.5938 7 10.9531C7 9.3125 8.35938 7.95312 10 7.95312C11.6406 7.95312 13 9.3125 13 10.9531C13 12.5938 11.6406 13.9531 10 13.9531Z",
    fill: "#212121",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentMention);
export default __webpack_public_path__ + "static/media/comment-mention.43ff144d8f495540193b88a6139c4cb7.svg";
export { ForwardRef as ReactComponent };